import { createSelector } from 'reselect';

const photoGalleryState = (state) => state.profile.photoGallery;

export const selectPhotoGalleryData = createSelector(photoGalleryState, (state) => state.data);
export const selectPhotoGalleryLoading = createSelector(photoGalleryState, (state) => state.isLoading);
